/**
 * Returns { wrapper, img } where each value is
 * a ready-to-paste inline-style string.
 */
export function cropStyles(tlx: number, tly: number, brx: number, bry: number, w: number, h: number) {
  if (tlx === brx || tly === bry || w === 0 || h === 0) {
    return { wrapper: "", img: "" };
  }
  const cropWidth = (brx - tlx) / w;
  const scale = 1 / cropWidth;

  const wrapper = ["position:relative", "overflow:hidden", "width:100%", `aspect-ratio:${brx - tlx}/${bry - tly}`].join(
    ";"
  );

  const img = [
    "position:absolute",

    `width:${100 * scale}%`,
    "height:auto",
    "max-width:none !important",
    `left:-${(tlx / (brx - tlx)) * 100}%`,
    `top:-${(tly / (bry - tly)) * 100}%`
  ].join(";");

  return { wrapper, img };
}
